'use strict';

DataTagsCreateController.$inject = [
  '$modal',
  '$scope',
  '$timeout',
  '$miscUtils',
  'DataTagDomain',
  '$toast',
  'dataTag',
];

const renameInterval = 60 * 60 * 1000; // renaming is allowed for 1 hour

export function DataTagsCreateController($modal, $scope, $timeout, $miscUtils, DataTagDomain, $toast, existingTag) {
  let nameEditTimeout;
  const vm = $scope.dataTagCreate = this;
  vm.save = $miscUtils.blockPromise(save);
  vm.cancel = cancel;

  vm.getHeader = getHeader;
  vm.canEditForm = !existingTag; // TODO: temporary measure until server supports changing forms

  initViewModel(existingTag);


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function save() {
    if (!vm.model.$validate())
      return Promise.reject(vm.model.$errors);

    return (existingTag ? DataTagDomain.update(vm.model) : DataTagDomain.create(vm.model)).then(function (dataTag) {
      if (!existingTag) {
        vm.model = dataTag;
        $toast.showI18nMessage({
          messageId: 'data.tags.create.success.message',
          messageParams: {tagName: vm.model.name},
          type: 'info',
        });
      }
      return $modal.hide(dataTag);
    }, function (error) {
      console.error(error);
    });// TODO: show errors in view
  }

  function cancel() {
    if (existingTag) existingTag.$revert();
    return $modal.cancel();
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function getHeader() {
    return existingTag ? 'data.tags.update.header.label' : 'data.tags.create.header.label';
  }


  /*****************************************************************************************************************
   * Load Data
   ****************************************************************************************************************/


  function initViewModel(dataTag) {
    vm.model = dataTag ? dataTag : DataTagDomain.$factory.create();

    const dateCreated = vm.model.dateCreated.getTime();
    const expires = renameInterval + dateCreated - 60 * 1000; // 1 minute buffer
    const timeRemaining = expires - new Date().getTime();

    if (!dataTag) {
      vm.editName = true; // the clock starts when it gets saved to the DB
    } else if (timeRemaining > 0) {
      vm.editName = true;
      nameEditTimeout = $timeout(disableEditName, timeRemaining);
      $scope.$on('$destroy', cleanup);
    } else {
      vm.editName = false;
    }
  }

  function disableEditName() {
    vm.model.$revert('name');
    vm.editName = false;
  }

  function cleanup() {
    $timeout.cancel(nameEditTimeout);
  }
}



// WEBPACK FOOTER //
// ./src/js/data-tags/controllers/DataTagsCreateController.js